import { Button, Switch, Typography } from '@mui/material'
import { useAppServices } from 'hook/services';
import React, { useEffect, useState } from 'react'

const BespokeIntegrations = ({ loading, agency, Update }) => {
    const Service = useAppServices();
    const [integrations, setIntegrations] = React.useState([]);
    const [active, setActiveIntegrations] = React.useState(agency?.active_integrations || []);
    const [loader, setLoader] = useState(false)
    const getIntegrations = async () => {
        const { response } = await Service.integrations.availableBranding();
        if (response?.success) {
            setIntegrations(response.data);
        }
    }

    const saveIntegrations = async () => {
        setLoader(true);
        const payload = {
            active_integrations: active,
            _id: agency._id
        }
        const { response } = await Service.agency.update({ payload });
        if (response?.success) {
            Update({ active_integrations: active });
        } else {
            alert("Failed to update integrations")
        }
        setLoader(false)
    }

    useEffect(() => {
        setActiveIntegrations(agency?.active_integrations || []);
    }, [agency])

    useEffect(() => {
        getIntegrations();
    }, [])

    return (
        <div style={{ display: "block" }}>
            {integrations?.map((integration, index) => (
                <div key={index} style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "8px", alignItems: "center" }}>
                    <Typography sx={{ textTransform: "capitalize", fontSize: "18px" }}>
                        {integration?.provider}
                    </Typography>
                    <Switch checked={active.includes(integration?.provider)} onChange={() => {
                        if (active.includes(integration?.provider)) {
                            setActiveIntegrations(active.filter(item => item !== integration?.provider));
                        } else {
                            setActiveIntegrations([...active, integration?.provider]);
                        }
                    }} />
                </div>
            ))}
            <div style={{
                display: "flex", width: "100%", justifyContent: "end", marginTop: "12px"
            }}>
                <Button
                    onClick={saveIntegrations}
                    disabled={loading || loader}
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: "10px" }}
                >
                    save
                </Button>
            </div>
        </div>
    )
}

export default BespokeIntegrations